class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      this.closest("cart-items").updateQuantity(this.dataset.index, 0);
    });
  }
}
customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById(
      "shopping-cart-line-item-status"
    );
    this.cartErrors = document.getElementById("cart-errors");

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener("change", this.debouncedOnChange.bind(this));

    this.addEventListener("change", (event) => {
      if (event.target === null) return;

      if (event.target.getAttribute("name") === "updates[]") {
        this.updateQuantity(
          event.target.dataset.index,
          event.target.value,
          "updates[]"
        );
      }
    });

    this.addEventListener("click", this.onSubButtonClick.bind(this));
  }

  onChange(event) {
    if (event.target === null) return;
    if (event.target.getAttribute("name") === "updates[]") {
      this.updateQuantity(
        event.target.dataset.index,
        event.target.value,
        "updates[]"
      );
    }
  }

  getSectionsToRender() {
    let sections = [
      {
        id: "mini-cart",
        section: document.getElementById("mini-cart")?.id,
        selector: ".shopify-section",
      },
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items")?.dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "mobile-cart-icon-bubble",
        section: "mobile-cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer")?.dataset.id,
        selector: ".js-contents",
      },
    ];
    if (document.querySelector("#main-cart-footer .free-shipping")) {
      sections.push({
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer")?.dataset.id,
        selector: ".free-shipping",
      });
    }
    return sections;
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);
    const sections = this.getSectionsToRender().map(
      (section) => section.section
    );

    const body = JSON.stringify({
      line,
      quantity,
      sections: sections,
      sections_url: window.location.pathname,
    });

    fetch(`${window.routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartFooter = document.getElementById("main-cart-footer");

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (parsedState.errors) {
          this.updateErrorLiveRegions(line, parsedState.errors);
        }
        this.getSectionsToRender().forEach((section) => {
          const element = document.getElementById(section.id);
          if (element) {
            const elementToReplace =
              element.querySelector(section.selector) || element;

            if (elementToReplace && parsedState.sections[section.section]) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              );
            }
          }
        });

        this.updateQuantityLiveRegions(line, parsedState.item_count);

        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && name)
          lineItem.querySelector(`[name="${name}"]`).focus();
        this.disableLoading();

        document.dispatchEvent(
          new CustomEvent("cart:updated", {
            detail: {
              cart: state,
            },
          })
        );
        publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-items" });
      })
      .catch(() => {
        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        this.disableLoading();
        if (this.cartErrors) {
          this.cartErrors.textContent = window.cartStrings.error;
        }
      });
  }

  replaceCartItem(key, quantity) {
    //this.enableLoading(line);
    console.log("replaceCartItem function called");
    const sections = this.getSectionsToRender().map(
      (section) => section.section
    );

    const body = JSON.stringify({
      id: key,
      quantity,
      sections: sections,
      sections_url: window.location.pathname,
    });

    fetch(`${window.routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.getSectionsToRender().forEach((section) => {
          const element = document.getElementById(section.id);
          if (element) {
            const elementToReplace =
              element.querySelector(section.selector) || element;

            if (elementToReplace && parsedState.sections[section.section]) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              );
            }
          }
        });

        this.disableLoading();

        document.dispatchEvent(
          new CustomEvent("cart:updated", {
            detail: {
              cart: state,
            },
          })
        );
        publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-items" });
      })
      .catch(() => {
        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        this.disableLoading();
        if (this.cartErrors) {
          this.cartErrors.textContent = window.cartStrings.error;
        }
      });
  }

  onSubButtonClick(event) {
    if (event.target.classList.contains("add-selling-plan__button")) {
      const subSelect = event.target;
      const sellingPlan = subSelect.getAttribute("data-selling-plan");
      const line = subSelect.getAttribute("data-index");
      const freeGiftVariantId = subSelect.getAttribute(
        "data-free-gift-variant-id"
      );
      const variantId = subSelect.getAttribute("data-variant-id");

      this.handleSubSelection(subSelect);
      this.updateSellingPlan(line, variantId, sellingPlan, freeGiftVariantId);
    }
  }

  handleSubSelection(line, sellingPlan) {
    console.log("handleSubSelection function called");
    //const attribute =  event.target.querySelector.('add-selling-plan__button').getAttribute('name');

    document.querySelectorAll(`add-selling-plan__button`).forEach((button) => {
      console.log("button attribute found");
      button.setAttribute(
        "data-selling-plan",
        subSelect.getAttribute("data-selling-plan")
      );
    });
    console.log("sellingPlan original:", sellingPlan);
  }

  updateSellingPlan(line, variantId, sellingPlan, freeGiftVariantId) {
    //console.log('updateSellingPlan function called');
    this.enableLoading(line);
    const sections = this.getSectionsToRender().map(
      (section) => section.section
    );

    // Check if the selling_plan property is null before updating it
    if (sellingPlan === null) {
      sellingPlan = sellingPlan;
    }
    console.log("sellingPlan updated:", sellingPlan);

    let cartItem = {
      line: line,
      id: variantId,
      quantity: 1,
      selling_plan: sellingPlan,
      sections: sections,
      sections_url: window.location.pathname,
    };

    //console.log(body);

    fetch(`${window.routes.cart_change_url}`, {
      ...fetchConfig(),
      body: JSON.stringify(cartItem),
    })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartFooter = document.getElementById("main-cart-footer");

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (parsedState.errors) {
          this.updateErrorLiveRegions(line, parsedState.errors);
        }
        this.getSectionsToRender().forEach((section) => {
          const element = document.getElementById(section.id);
          if (element) {
            const elementToReplace =
              element.querySelector(section.selector) || element;

            if (elementToReplace && parsedState.sections[section.section]) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              );
            }
          }
        });

        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && name)
          lineItem.querySelector(`[name="${name}"]`).focus();
        this.disableLoading();

        document.dispatchEvent(
          new CustomEvent("cart:updated", {
            detail: {
              cart: state,
            },
          })
        );
        publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-items" });
      })
      .catch(() => {
        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        this.disableLoading();
        if (this.cartErrors) {
          this.cartErrors.textContent = window.cartStrings.error;
        }
      });

    if (window.isES && freeGiftVariantId) {
      setTimeout(() => {
        this.addFreeGift(line, freeGiftVariantId);
      }, 300);
    }
  }

  addFreeGift(line, freeGiftVariantId) {
    this.enableLoading(line);
    const sections = this.getSectionsToRender().map(
      (section) => section.section
    );
    console.log(freeGiftVariantId);

    if (window.isES && freeGiftVariantId) {
      let freeItem = {
        id: freeGiftVariantId,
        quantity: 1,
        properties: {
          _igGWP: "1",
        },
        sections: sections,
        sections_url: window.location.pathname,
      };
    }

    fetch(`${window.routes.cart_add_url}`, {
      ...fetchConfig(),
      body: JSON.stringify(freeItem),
    })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const cartFooter = document.getElementById("main-cart-footer");

        this.getSectionsToRender().forEach((section) => {
          const element = document.getElementById(section.id);
          if (element) {
            const elementToReplace =
              element.querySelector(section.selector) || element;

            if (elementToReplace && parsedState.sections[section.section]) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              );
            }
          }
        });

        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && name)
          lineItem.querySelector(`[name="${name}"]`).focus();
        this.disableLoading();

        this.updateQuantityLiveRegions(line, parsedState.item_count);

        document.dispatchEvent(
          new CustomEvent("ajaxProduct:added", {
            detail: {
              product: parsedState,
            },
          })
        );
      })
      .catch(() => {
        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        this.closest("cart-items").disableLoading();
        if (this.cartErrors) {
          this.cartErrors.textContent = window.cartStrings.error;
        }
      });
  }

  updateErrorLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError)
      lineItemError.querySelector(".cart-item__error-text").innerHTML = message;

    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  updateQuantityLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const quantityError = document.getElementById(`Line-item-error-${line}`);
      if (quantityError) {
        quantityError.querySelector(".cart-item__error-text").innerHTML =
          window.cartStrings.quantityError.replace(
            "[quantity]",
            document.getElementById(`Quantity-${line}`).value
          );
      }
    }

    this.currentItemCount = itemCount;

    if (this.lineItemStatusElement)
      this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus = document.getElementById("cart-live-region-text");
    if (cartStatus) {
      cartStatus.setAttribute("aria-hidden", false);

      setTimeout(() => {
        cartStatus.setAttribute("aria-hidden", true);
      }, 1e3);
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector)?.innerHTML;
  }

  enableLoading(line) {
    const cartItems = document.getElementById("main-cart-items");
    if (cartItems) cartItems.classList.add("cart__items--disabled");

    const loadingOverlay = this.querySelectorAll(".loading-overlay")[line - 1];
    if (loadingOverlay) loadingOverlay.classList.remove("hidden");

    document.activeElement.blur();
    if (this.lineItemStatusElement)
      this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading() {
    const cartItems = document.getElementById("main-cart-items");
    if (cartItems) cartItems.classList.remove("cart__items--disabled");
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section) => {
      const element = document.getElementById(section.id);

      if (element && parsedState.sections[section.id]) {
        element.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );
      }
    });
  }

  async removeByKey(key) {
    const sections = this.getSectionsToRender().map(
      (section) => section.section
    );
    const requestBody = JSON.stringify({
      id: key,
      quantity: 0,
      sections: sections,
      sections_url: window.location.pathname,
    });
    const response = await fetch(window.routes.cart_change_url, {
      ...fetchConfig(),
      ...{ body: requestBody },
    });
    const state = await response.json();
    return state;
  }
}
customElements.define("cart-items", CartItems);

class CartNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "change",
      debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${window.routes.cart_update_url}`, {
          ...fetchConfig(),
          ...{ body },
        });
      }, 300)
    );
  }
}
customElements.define("cart-note", CartNote);

class DiscountCode extends HTMLElement {
  constructor() {
    super();

    if (isStorageSupported("session")) {
      this.setupDiscount();

      this.addEventListener("change", (event) => {
        window.sessionStorage.setItem("discount", event.target.value);
      });
    }
  }

  setupDiscount() {
    const discount = window.sessionStorage.getItem("discount");
    if (discount !== null) {
      this.querySelector('input[name="discount"]').value = discount;
    }
  }
}

customElements.define("discount-code", DiscountCode);

class ShippingCalculator extends HTMLElement {
  constructor() {
    super();

    this.setupCountries();

    this.errors = this.querySelector("#ShippingCalculatorErrors");
    this.success = this.querySelector("#ShippingCalculatorSuccess");
    this.zip = this.querySelector("#ShippingCalculatorZip");
    this.country = this.querySelector("#ShippingCalculatorCountry");
    this.province = this.querySelector("#ShippingCalculatorProvince");
    this.button = this.querySelector("button");
    this.button.addEventListener("click", this.onSubmitHandler.bind(this));
  }

  setupCountries() {
    if (Shopify && Shopify.CountryProvinceSelector) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(
        "ShippingCalculatorCountry",
        "ShippingCalculatorProvince",
        {
          hideElement: "ShippingCalculatorProvinceContainer",
        }
      );
    }
  }

  onSubmitHandler(event) {
    event.preventDefault();

    this.errors.classList.add("hidden");
    this.success.classList.add("hidden");
    this.zip.classList.remove("invalid");
    this.country.classList.remove("invalid");
    this.province.classList.remove("invalid");
    this.button.classList.add("loading");
    this.button.setAttribute("disabled", true);

    const body = JSON.stringify({
      shipping_address: {
        zip: this.zip.value,
        country: this.country.value,
        province: this.province.value,
      },
    });
    let sectionUrl = `${window.routes.cart_url}/shipping_rates.json`;

    // remove double `/` in case shop might have /en or language in URL
    sectionUrl = sectionUrl.replace("//", "/");

    fetch(sectionUrl, { ...fetchConfig("javascript"), body })
      .then((response) => response.json())
      .then((parsedState) => {
        if (parsedState.shipping_rates) {
          this.success.classList.remove("hidden");
          this.success.innerHTML = "";

          parsedState.shipping_rates.forEach((rate) => {
            const child = document.createElement("p");
            child.innerHTML = `${rate.name}: ${rate.price} ${Shopify.currency.active}`;
            this.success.appendChild(child);
          });
        } else {
          let errors = [];
          Object.entries(parsedState).forEach(([attribute, messages]) => {
            errors.push(
              `${attribute.charAt(0).toUpperCase() + attribute.slice(1)} ${
                messages[0]
              }`
            );
          });

          this.errors.classList.remove("hidden");
          this.errors.querySelector(".errors").innerHTML = errors.join("; ");
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.button.classList.remove("loading");
        this.button.removeAttribute("disabled");
      });
  }
}

customElements.define("shipping-calculator", ShippingCalculator);

class SubscriptionUpgrade extends HTMLElement {
  constructor() {
    super();
    //this.miniCart = document.querySelector('mini-cart');
    this.cartItems = document.querySelector("cart-items");

    this.lineItemStatusElement = document.getElementById(
      "shopping-cart-line-item-status"
    );
    this.cartErrors = document.getElementById("cart-errors");

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );

    this.addEventListener("click", this.onButtonClick.bind(this));
  }
  onButtonClick(event) {
    console.log("onButtonClick function called");

    if (event.target.classList.contains("upgrade-selling-plan__button")) {
      console.log("selling plan button function called");
      const subSelect = event.target;
      const sellingPlan = subSelect.getAttribute("data-selling-plan");
      const variantId = subSelect.getAttribute("data-variant-id");
      const line = subSelect.getAttribute("data-index");
      const key = subSelect.getAttribute("data-item-key");
      const freeGiftVariantId = subSelect.getAttribute(
        "data-free-gift-variant-id"
      );

      this.updateCart(line, variantId, sellingPlan, freeGiftVariantId, key);
    }
  }

  updateCart(line, variantId, sellingPlan, freeGiftVariantId, oldItemKey) {
    const cartItems = this.closest("cart-items");
    cartItems.enableLoading(line);
    this.setAttribute("disabled", true);
    this.classList.add("loading");
    //const sections = this.miniCart ? this.miniCart.getSectionsToRender().map((section) => section.id) : [];
    const sections = cartItems
      .getSectionsToRender()
      .map((section) => section.section);
    if (variantId) {
      if (sellingPlan === null) {
        sellingPlan = null;
      }

      let cartItem = {
        items: [
          {
            id: variantId,
            quantity: 1,
            selling_plan: sellingPlan,
          },
        ],
        sections: sections,
        sections_url: window.location.pathname,
      };

      if (window.isES && freeGiftVariantId) {
        cartItem.items.push({
          id: freeGiftVariantId,
          quantity: 1,
          properties: {
            _igGWP: "1",
          },
        });
      }

      fetch(`${window.routes.cart_add_url}`, {
        ...fetchConfig(),
        body: JSON.stringify(cartItem),
      })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);

          if (oldItemKey) {
            cartItems.replaceCartItem(oldItemKey, 0);
          } else {
            this.getSectionsToRender().forEach((section) => {
              const element = document.getElementById(section.id);
              if (element) {
                const elementToReplace =
                  element.querySelector(section.selector) || element;

                if (elementToReplace && parsedState.sections[section.section]) {
                  elementToReplace.innerHTML = this.getSectionInnerHTML(
                    parsedState.sections[section.section],
                    section.selector
                  );
                }
              }
            });
            this.disableLoading();
          }

          const lineItem = document.getElementById(`CartItem-${line}`);
          if (lineItem && name)
            lineItem.querySelector(`[name="${name}"]`).focus();

          cartItems.updateQuantityLiveRegions(line, parsedState.item_count);

          document.dispatchEvent(
            new CustomEvent("ajaxProduct:added", {
              detail: {
                product: parsedState,
              },
            })
          );
        })
        .catch(() => {
          this.querySelectorAll(".loading-overlay").forEach((overlay) =>
            overlay.classList.add("hidden")
          );
          cartItems.disableLoading();
          if (this.cartErrors) {
            this.cartErrors.textContent = window.cartStrings.error;
          }
        });
    }
  }
}
customElements.define("subscription-upgrade", SubscriptionUpgrade);

class VariantSelect extends HTMLElement {
  constructor() {
    super();
    /** @type {CartItems} */
    this.cartItemsEl = this.closest("cart-items");
    this.querySelector("select").addEventListener(
      "change",
      this.onVariantSelect.bind(this)
    );
  }

  /**
   * @param {Event} event
   */
  async onVariantSelect(event) {
    event.stopPropagation();
    /** @type {HTMLSelectElement|null} */
    const sel = event.currentTarget;
    this.cartItemsEl.enableLoading(sel.dataset.index);
    // @TODO Build free gift selection modal logic?
    const lineNum = sel.dataset.index;
    const variantId = sel.options[sel.selectedIndex].value;
    const sellingPlanId = sel.options[sel.selectedIndex].dataset.sellingPlan;
    const item = {
      line: lineNum,
      id: variantId,
      selling_plan: sellingPlanId,
      properties: {},
    };
    let igPrice;
    for (let i = 0; i < sel.options.length; i++) {
      igPrice = window.igData.price.getPriceByVariantId(sel.options[i].value);
      if (igPrice) {
        item.properties[`_igp_${sel.options[i].value}`] = igPrice * 100;
      }
    }
    await this.cartItemsEl.removeByKey(sel.dataset.itemKey);
    const state = await this.addItem(item, null);

    document.dispatchEvent(
      new CustomEvent("cart:updated", {
        detail: {
          cart: state,
        },
      })
    );
    publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-items" });
  }

  /**
   * @param {{line: number, id: number, selling_plan?: number, properties?: object}} item
   * Here `id` is the variantId; `properties` is an object for items that have
   * an active price test, the keys follow a format of `_igp_{variant_id}` and
   * the values are the bulk discounted price for the variant
   */
  async addItem(item, freeGiftVariantId) {
    if (!item.id) {
      return;
    }
    item.quantity = 1;
    const sections = this.cartItemsEl
      .getSectionsToRender()
      .map((section) => section.section);
    const cartRequestBody = {
      items: [item],
      sections: sections,
      sections_url: window.location.pathname,
    };
    if (window.isES && freeGiftVariantId) {
      cartRequestBody.items.push({
        id: freeGiftVariantId,
        quantity: 1,
        properties: {
          _igGWP: "1",
        },
      });
    }
    try {
      const response = await fetch(window.routes.cart_add_url, {
        ...fetchConfig(),
        body: JSON.stringify(cartRequestBody),
      });
      const state = await response.json();
      document.dispatchEvent(
        new CustomEvent("ajaxProduct:added", {
          detail: {
            product: state,
          },
        })
      );
      return state;
    } catch {
      this.cartItemsEl
        .querySelectorAll(".loading-overlay")
        .forEach((overlay) => overlay.classList.add("hidden"));
      this.cartItemsEl.disableLoading();
      if (this.cartItemsEl.cartErrors) {
        this.cartItemsEl.cartErrors.textContent = window.cartStrings.error;
      }
    }
  }
}
customElements.define("variant-select", VariantSelect);

class RecommendationSelect extends HTMLElement {
  constructor() {
    super();
    this.miniCart = document.querySelector("mini-cart");

    this.lineItemStatusElement = document.getElementById(
      "shopping-cart-line-item-status"
    );
    this.cartErrors = document.getElementById("cart-errors");
    this.addEventListener("change", this.onRecommendationSelect.bind(this));
  }
  onRecommendationSelect(event) {
    event.preventDefault();
    console.log("onvariant select");
    const recommendationSelect = event.target;
    const variantId =
      recommendationSelect.options[
        recommendationSelect.selectedIndex
      ].getAttribute("data-variant-id");
    console.log("variant change", variantId);

    if (variantId) {
      if (
        document.body.classList.contains("template-cart") ||
        !window.shopSettings.cartDrawer
      ) {
        Shopify.postLink(window.routes.cart_add_url, {
          parameters: {
            id: variantId,
            quantity: 1,
          },
        });
        return;
      }

      this.setAttribute("disabled", true);
      this.querySelector("select").closest(".button").classList.add("loading");
      const sections = this.miniCart
        ? this.miniCart.getSectionsToRender().map((section) => section.id)
        : [];

      const body = JSON.stringify({
        id: variantId,
        quantity: 1,
        sections: sections,
        sections_url: window.location.pathname,
      });

      fetch(`${window.routes.cart_add_url}`, {
        ...fetchConfig("javascript"),
        body,
      })
        .then((response) => response.json())
        .then((parsedState) => {
          if (parsedState.status === 422) {
            document.dispatchEvent(
              new CustomEvent("ajaxProduct:error", {
                detail: {
                  errorMessage: parsedState.description,
                },
              })
            );
          } else {
            this.miniCart && this.miniCart.renderContents(parsedState);

            document.dispatchEvent(
              new CustomEvent("ajaxProduct:added", {
                detail: {
                  product: parsedState,
                },
              })
            );
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.querySelector("select")
            .closest(".button")
            .classList.remove("loading");
          this.removeAttribute("disabled");
        });
    }
  }
}
customElements.define("recommendation-select", RecommendationSelect);

document.addEventListener('cart:updated', (e) => {
  const cartItemsEl = document.querySelector("cart-items");
  cartItemsEl.renderContents(e.detail.cart);
  cartItemsEl.disableLoading();
});
